import React from "react";
import ProjectShowcase from "../../components/ProjectShowcase/ProjectShowcase.js";

import "./Projects.css";
const Projects = () => {
  return (
    <div className="page-container">
      <ProjectShowcase />
    </div>
  );
};

export default Projects;
